import produce from 'immer';
import {
  GIOTALK_ESTABLECER_CONNECIONID,
  GIOTALK_MODIFICAR_NOTIFICACIONES,
  GIOTALK_INCREMENTAR_NO_LEIDAS,
  GIOTALK_NOTIFICACIONES_LIMPIAR,
  GIOTALK_NOTIFICACIONES_MARCAR_TODO_LEIDO,
  GIOTALK_NOTIFICACIONES_ESTABLECER_SUSCRIPCIONES,
  GIOTALK_CHATS_ESTABLECER_CHAT_ACTUAL,
  GIOTALK_CHATS_MENSAJES_ADD_PENDIENTE,
  GIOTALK_CHATS_MENSAJES_CONFIRMAR_ENVIO,
  GIOTALK_CHATS_CREAR_ADD_PENDIENTE,
  GIOTALK_CHATS_OBTENER_CARGAR,
  GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_CARGAR,
  GIOTALK_CHATS_ESTABLECER_ULTMO_MENSAJE, GIOTALK_CHAT_ELIMINAR, GIOTALK_INSERTAR_USUARIOS_A_CHAT,
} from '../actions/constants/giotalk.constants';
import { deepClone } from '../../helpers/object.helper';

const initialState = {
  connectionId: null,

  notificaciones: {
    id: 'notificaciones',
    nombre: 'Canal Gio Web',
    tipo: 'notificaciones',
    descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In varius scelerisque maximus. Morbi sodales nec erat ut varius. Vestibulum dapibus dolor tempor tincidunt tristique.',
    total: null,
    totalNoLeido: null,
    mensajes: [],
    hayNuevas: null,
    subscripciones: [],
  },

  chats: [],
  chatSeleccionadoId: null,

};

export default function mensajesSistema(state = initialState, { type, payload }) {
  switch (type) {
    case GIOTALK_ESTABLECER_CONNECIONID: {
      const { connectionId } = payload;
      return {
        ...state,
        connectionId,
      };
    }
    case GIOTALK_MODIFICAR_NOTIFICACIONES: {
      const { datos, total, totalNoLeido } = payload;
      const { notificaciones } = state;
      const notificacionesCopy = {
        ...notificaciones,
        total,
        totalNoLeido,
        mensajes: datos,
        hayNuevas: false,
      };
      return {
        ...state,
        notificaciones: notificacionesCopy,
      };
    }
    case GIOTALK_INCREMENTAR_NO_LEIDAS: {
      const { notificaciones, notificaciones: { totalNoLeido } } = state;
      const nuevoTotalNoLeido = (totalNoLeido !== null) ? (totalNoLeido + 1) : 1;
      const notificacionesCopy = {
        ...notificaciones,
        totalNoLeido: nuevoTotalNoLeido,
        hayNuevas: true,
      };
      return {
        ...state,
        notificaciones: notificacionesCopy,
      };
    }
    case GIOTALK_NOTIFICACIONES_LIMPIAR: {
      const { notificaciones } = state;
      return {
        ...state,
        notificaciones: {
          ...notificaciones,
          mensajes: [],
        },
      };
    }
    case GIOTALK_NOTIFICACIONES_ESTABLECER_SUSCRIPCIONES: {
      const { notificaciones } = state;
      const { subscripciones } = payload;
      return {
        ...state,
        notificaciones: {
          ...notificaciones,
          subscripciones,
        },
      };
    }
    case GIOTALK_NOTIFICACIONES_MARCAR_TODO_LEIDO: {
      const { notificaciones } = state;
      return {
        ...state,
        notificaciones: {
          ...notificaciones,
          totalNoLeido: 0,
        },
      };
    }
    case GIOTALK_CHATS_ESTABLECER_CHAT_ACTUAL: {
      const { id } = payload;
      return {
        ...state,
        chatSeleccionadoId: id,
      };
    }
    case GIOTALK_CHATS_MENSAJES_ADD_PENDIENTE: {
      const { chatId, mensaje } = payload;
      return produce(state, (draftState) => {
        const { chats } = draftState;
        const chatSeleccionado = chats.find(chat => chat.id === chatId);
        if (chatSeleccionado) {
          chatSeleccionado.mensajes.push(mensaje);
        }
      });
    }
    case GIOTALK_CHATS_MENSAJES_CONFIRMAR_ENVIO: {
      const { chatId, mensajeId } = payload;
      const { chats } = state;
      const chatSeleccionadoCopy = chats.find(chat => chat.id == chatId);
      const mensajesModificados = deepClone(chatSeleccionadoCopy.mensajes).map((mensaje) => {
        const { id } = mensaje;
        if (id === mensajeId) {
          return {
            ...mensaje,
            pending: false,
          };
        }
        return mensaje;
      });
      const chatsModificados = deepClone(chats).map((chat) => {
        const { id } = chat;
        if (id == chatId) chat.mensajes = mensajesModificados;
        return chat;
      });
      return {
        ...state,
        chats: chatsModificados,
      };
    }
    case GIOTALK_CHATS_CREAR_ADD_PENDIENTE: {
      const { chats } = state;
      const { name, id, usuarios } = payload;
      const pendingChat = {
        id,
        nombre: name,
        mensajes: [],
        createdAt: new Date(),
        usuarios,
      };
      const chatsCopy = [
        ...chats,
      ];
      chatsCopy.unshift(pendingChat);
      return {
        ...state,
        chats: chatsCopy,
        chatCreadoId: id,
      };
    }
    case GIOTALK_CHATS_OBTENER_CARGAR: {
      const { chats } = payload;
      const { chats: chatsFromState } = state;

      const chatsByKeyId = [];
      chatsFromState.forEach((chat) => {
        const { id } = chat;
        chatsByKeyId[id] = deepClone(chat);
      });

      const chatsMapped = chats.map((chat) => {
        const {
          id, totalNoLeido, lastMessage, usuarios,
        } = chat;
        const chatFromState = chatsByKeyId[id];
        if (chatFromState) {
          return {
            ...chatFromState,
            totalNoLeido,
            lastMessage,
            usuarios,
          };
        }
        return {
          ...chat,
        };
      });

      return {
        ...state,
        chats: chatsMapped,
      };
    }
    case GIOTALK_CHATS_MENSAJES_BUSCAR_MENSAJES_CARGAR: {
      const { chatId, mensajes, total, totalNoLeido } = payload;
      const { chats } = state;

      const chatsSeleccionadoCopy = deepClone(chats);

      const chatsModificados = chatsSeleccionadoCopy.map((chat) => {
        const { id } = {
          ...chat,
        };
        if (id === chatId) {
          return {
            ...chat,
            total,
            mensajes,
            totalNoLeido,
          };
        }
        return chat;
      });

      return {
        ...state,
        chats: chatsModificados,
      };
    }
    case GIOTALK_CHATS_ESTABLECER_ULTMO_MENSAJE: {
      const { chatId, mensaje } = payload;
      const { chats } = state;
      const chatsCopy = deepClone(chats);

      const chatsModificados = chatsCopy.map((chat) => {
        const { id } = chat;
        if (id == chatId) chat.lastMessage = deepClone(mensaje);
        return chat;
      });

      return {
        ...state,
        chats: chatsModificados,
      };
    }
    case GIOTALK_CHAT_ELIMINAR: {
      const { chatId } = payload;
      const { chats } = state;
      const chatsWithoutRemoved = deepClone(chats).filter((chat) => {
        const { id: filteredId } = chat;
        return filteredId !== chatId;
      });
      return {
        ...state,
        chats: chatsWithoutRemoved,
      };
    }
    case GIOTALK_INSERTAR_USUARIOS_A_CHAT: {
      const { chatId, usuarios: usuariosPayload } = payload;
      const { chats } = state;
      const chatsModificados = deepClone(chats).map((chat) => {
        const { id: chatIdMap } = chat;
        if (chatId === chatIdMap) {
          const { usuarios } = chat;
          return {
            ...chat,
            usuarios: [...usuarios, ...usuariosPayload],
          };
        }
        return chat;
      });

      return {
        ...state,
        chats: chatsModificados,
      };
    }
    default: {
      return state;
    }
  }
}
